import IdvRejected from './idv-failed';

export default IdvRejected;
